<div class="flex flex-col align-stretch w-full">
	<div class="flex justify-end">
		<app-button
			[icon]="ICON.CLOSE"
			btn="clear"
			size="small"
			(onClick)="close()"
		></app-button>
	</div>
	<h3>Sorry You Don't Have Access</h3>
	<p class="text-grey mb-4">Contact your administrator to manage templates.</p>
	<app-contact-admin-users></app-contact-admin-users>
</div>
